import { sagas as amenitiesSagas } from './modules/amenities'
import { sagas as upcomingReservations } from './modules/upcomingReservations'

export default [...amenitiesSagas, ...upcomingReservations]
